<template>
  <el-button
    v-bind="$attrs"
    v-on="$listeners"
    class="base-button">
    <slot></slot>
  </el-button>
</template>

<script>
export default {
  name: 'BaseButton',
  inheritAttrs: false
};
</script>

<style scoped lang="scss">
.base-button {
  border-radius: 8px;
  font-weight: 500;
  padding: 9px 18px;
  height: auto;
  letter-spacing: 0.01em;
}
</style>
